<template>
    <div>
        <button v-if="!loading" type="button" @click="appendDataToModal" class="btn btn-sm btn-dark"
                data-toggle="modal">
            <span>{{ $t('label.description') }}</span>

        </button>
        <span v-else class="spinner-border spinner-border-sm"></span>

        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tx_title">
                        </div>
                        <div id="tx_log" class="ml-1">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="request_details" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead id="table-header">
                            <tr>
                                <th class="table-info" colspan="2">{{
                                        $t('label.detail_money_request_form')
                                    }}
                                </th>
                            </tr>
                            </thead>
                            <tbody id="request_details_body">
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import {openBankingService} from "@/common/api.service";
import {
    openBankingRequestsStatus,
    financialServices,
    authenticationServices,
    inquiryServices
} from '@/constants/openBanking'


export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
            loading: false,
            isError: false,
            openBankingRequestsStatus,
            financialServices,
            authenticationServices,
            inquiryServices
        }
    },

    methods: {
        async appendDataToModal() {
            this.loading = true;
            if (this.$can('read', 'open-banking')) {
                await openBankingService.adminFetchOpenBankingRequest(this.row.id).then(({data}) => {
                    this.data = data.data
                }).catch(() => {
                    this.isError = true;
                    this.toastr.error(i18n.t('message.an_error_accord'))
                }).finally(() => {
                    this.loading = false;
                })
            } else {
                await openBankingService.fetchOpenBankingRequest(this.row.id).then(({data}) => {
                    this.data = data.data
                }).catch(() => {
                    this.isError = true;
                    this.toastr.error(i18n.t('message.an_error_accord'))
                }).finally(() => {
                    this.loading = false;
                })

            }
            if (this.isError)
                return;
            $("#description_modal").modal('show')

            function simpleText(data, title) {
                return '<tr><td style="width: 155px">' + title + '</td>' +
                    '<td style="direction: ltr!important;">' + data + '</td></tr>'
            }

            function currencyText(data, title) {
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                    '<td>' + moneyFormat(data) + ' ' + i18n.t('currency.rial') + '</td></tr>'
            }

            function moneyFormat(price) {
                if (!price) return 0;
                const pieces = parseFloat(price).toFixed(0).split("");
                let ii = pieces.length;
                while ((ii -= 3) > 0) {
                    pieces.splice(ii, 0, ",");
                }
                return pieces.join("");
            }

            let title = $('#title').empty()
            let res = $('#res').empty()
            let ps_elements =
                '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.description') + ' ' + this.row.id + '</h4>'
            title.append(ps_elements)

            let request_details = this.data
            let request_details_body = $('#request_details_body').empty()
            let tx_title = $('#tx_title').empty()
            let tx_log = $('#tx_log').empty()

            let title_elements = '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.detail_money_request_form')+ ' ' + this.row.id + '</h4>'
            tx_title.append(title_elements)
            if (request_details.log_url) {
                let  log_elements = '<a href="' + request_details.log_url + '" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-sm"><i class="fa fa-history"></i></a>'
                tx_log.append(log_elements)
            }

            let service_type = this.data.service_type
            ps_elements = simpleText(i18n.t('application.services.'+service_type), i18n.t('open_banking.service_title'))
            request_details_body.append(ps_elements)

            Object.keys(request_details.input_data).forEach(function (field) {
                let field_str = field
                if (field == 'national_id')
                    field_str = i18n.t('label.national_code')
                else if (field == 'mobile_number')
                    field_str = i18n.t('label.phone')
                else if (field == 'birth_date')
                    field_str = i18n.t('label.birth_date')
                else if (field == 'card_number')
                    field_str = i18n.t('label.card_number')
                else if (field == 'iban')
                    field_str = i18n.t('label.iban')
                ps_elements = simpleText(request_details.input_data[field], field_str)
                request_details_body.append(ps_elements)
            });

            let request_ip = this.data.ip
            ps_elements = simpleText(request_ip, i18n.t('open_banking.request_ip'))
            request_details_body.append(ps_elements)

            if (this.data.status == this.openBankingRequestsStatus.SUCCESS) {
                let fee = this.data.fee
                ps_elements = currencyText(fee, i18n.t('open_banking.request_fee'))
                request_details_body.append(ps_elements)

                let wallet_balance_before_request = this.data.wallet_balance_before_request
                ps_elements = currencyText(wallet_balance_before_request, i18n.t('open_banking.wallet_balance_before_request'))
                request_details_body.append(ps_elements)

                let wallet_balance_after_request = this.data.wallet_balance_after_request
                ps_elements = currencyText(wallet_balance_after_request, i18n.t('open_banking.wallet_balance_after_request'))
                request_details_body.append(ps_elements)

                if (this.data.service_type == this.inquiryServices.IBAN_INQUIRY){
                    function formatOwnerInfo(ownersInfo) {
                        return ownersInfo.map(owner => {
                            return `${owner.firstName} ${owner.lastName}`;
                        }).join(', ');
                    }
                    const formattedOwnerInfo = formatOwnerInfo(request_details.result.owners_info);
                    ps_elements = simpleText(formattedOwnerInfo, i18n.t('pos.account_owner_name'))
                    request_details_body.append(ps_elements)

                    const bank_title = request_details.result.bank_title;
                    ps_elements = simpleText(bank_title, i18n.t('pos.bank'))
                    request_details_body.append(ps_elements)
                }
            }
            if (this.data.service_type.toUpperCase() in this.authenticationServices) {
                if (this.data.status == this.openBankingRequestsStatus.FAILED) {
                    ps_elements = simpleText(this.data.result, i18n.t('open_banking.failed_reason'))
                    request_details_body.append(ps_elements)
                }

                if (this.data.status == this.openBankingRequestsStatus.SUCCESS && this.data.result) {
                    let response = this.data.result;
                    let is_matched = null;
                    if (this.data.provider === 'SATPAY') {
                        if (response && response.data && response.data.result &&  response.data.result.isMatched) {
                            is_matched = i18n.t('open_banking.is_matched')
                        }else {
                            is_matched = i18n.t('open_banking.is_not_matched')
                        }
                    }
                    if(this.data.provider === 'SANBOD'){
                        if (response && response.message) {
                            if (response.message.ismatched !== undefined) {
                                is_matched = response.message.ismatched;
                                is_matched = is_matched ? i18n.t('open_banking.is_matched') : i18n.t('open_banking.is_not_matched');
                            }
                            if (response.message.isMatched !== undefined) {
                                is_matched = response.message.isMatched;
                                is_matched = is_matched ? i18n.t('open_banking.is_matched') : i18n.t('open_banking.is_not_matched');
                            }
                        }
                    }
                    if (is_matched) {
                        ps_elements = simpleText(is_matched, i18n.t('open_banking.is_matched_title'))
                        request_details_body.append(ps_elements)
                    }
                }
            }

            ps_elements = currencyText(this.data.company_wage, i18n.t('application.company_wage'))
            request_details_body.append(ps_elements)
            ps_elements = currencyText(this.data.provider_wage, i18n.t('application.provider_wage'))
            request_details_body.append(ps_elements)
            ps_elements = currencyText(this.data.company_tax, i18n.t('application.company_tax'))
            request_details_body.append(ps_elements)
            ps_elements = currencyText(this.data.provider_tax, i18n.t('application.provider_tax'))
            request_details_body.append(ps_elements)
        }
    },

    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
})
</script>

<style>

</style>
